import React from 'react';
import { DarkModeSwitch } from 'react-toggle-dark-mode';
import { useTheme } from '../contexts/ThemeContext';
import { useDesignMode } from '../contexts/DesignContext';
import { useTranslation } from 'react-i18next';
import { SketchButton } from './sketchy';

const ThemeToggle: React.FC = () => {
  const { theme, setTheme } = useTheme();
  const { isSketchy } = useDesignMode();
  const { t } = useTranslation();
  const isDark = theme === 'dark';

  if (isSketchy) {
    return (
      <SketchButton
        type="button"
        className="theme-toggle px-3 py-1 text-sm mr-2"
        aria-label={isDark ? t('theme.switchToLight') : t('theme.switchToDark')}
        data-testid="theme-toggle"
        onClick={() => setTheme(isDark ? 'light' : 'dark')}
      >
        <span className="theme-toggle__icon" aria-hidden>
          {isDark ? '☀️' : '🌙'}
        </span>
        <span className="label-typewriter text-xs">{isDark ? t('theme.day') : t('theme.night')}</span>
      </SketchButton>
    );
  }

  return (
    <button
      type="button"
      aria-label={isDark ? t('theme.switchToLight') : t('theme.switchToDark')}
      className="p-1 rounded-md hover:bg-gray-100 dark:hover:bg-gray-800 transition-colors mr-2"
      data-testid="theme-toggle"
      onClick={() => setTheme(isDark ? 'light' : 'dark')}
    >
      <DarkModeSwitch
        checked={isDark}
        onChange={(checked: boolean) => setTheme(checked ? 'dark' : 'light')}
        size={22}
        moonColor="#fff"
        sunColor="#000"
      />
    </button>
  );
};

export default ThemeToggle;
